import React, { useEffect, useRef, useState } from "react";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import {
  Chart,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title
} from "chart.js";

import styles from '../assets/css/gapsy-navbar.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckerChartreport, getshariahconfig } from '../components/ApiProperty';
import axios from "axios";
import { Modal } from 'react-bootstrap';

const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [dateFilterpdf, setDateFilterpdf] = useState("All");
  const [modalMessage, setModalMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // 'success', 'warning', 'danger'
  const [ApprovedTablespdf, setApprovedTablespdf] = useState([]);
  const [ReviewTablespdf, setReviewTablespdf] = useState([]);
  const [RejectedTablespdf, setRejectedTablespdf] = useState([]);
  const currentPath = location.pathname;
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [canDownloadShariahReport, setCanDownloadShariahReport] = useState(false);
  const [canDownloadComplaintsReport, setCanDownloadComplaintsReport] = useState(false);
  const [canDownloadMediaReport, setCanDownloadMediaReport] = useState(false);
  const [canDownloadOperationalReport, setCanDownloadOperationalReport] = useState(false);
  const [canDownloadLeadershipReport, setCanDownloadLeadershipReport] = useState(false);
  const [canDownloadComplianceReport, setCanDownloadComplianceReport] = useState(false);

  // Routes for 'Data Review'
  const dataReviewRoutes = ['/GapsyRData'];
  const isDataReviewActive = dataReviewRoutes.some(route => currentPath.startsWith(route));

  // Routes for 'Reports'
  const reportRoutes = ['/gapsyCaudit',
    '/gapsyTrendreport'];
  const isReportsActive = reportRoutes.some(route => currentPath.startsWith(route));

  let csrfToken = sessionStorage.getItem("tokenizedSession");
  const dept = localStorage.getItem("dept");

  useEffect(() => {
    fetchUsers();
  }, []);

  // const fetchUsers = async () => {
  //   try {

  //     const config = {
  //       headers: {
  //         userId: localStorage.getItem("userid"),
  //         "x-csrf-token": csrfToken,
  //       },
  //       withCredentials: true,
  //       params: {
  //         userId: localStorage.getItem("userid"),
  //         // templateName: "Risk_shariah_pillar1",
  //         templateName: "Shariah Risk",
  //       },
  //     };

  //     const response = await axios.post(getshariahconfig, {}, config);

  //     const apiData = [{
  //       templateName: response.data.templateName,
  //       permissions: response.data.data,
  //     }];

  //     // setSelectedTemplate(response.data.templateName);
  //     setUsers(apiData);
  //     setFilteredUsers(apiData);

  //     const loggedInUserId = localStorage.getItem("userid");

  //     const hasDownloadPermission = response.data.data.some(
  //       (item) =>
  //         item.userId === loggedInUserId &&
  //         item.download === "Y"
  //     );

  //     setCanDownloadShariahReport(hasDownloadPermission);

  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const fetchUsers = async () => {
    try {
      setIsLoading(true);

      const loggedInUserId = String(
        localStorage.getItem("userid") || ""
      );

      const baseConfig = {
        headers: {
          userId: loggedInUserId,
          "x-csrf-token": csrfToken,
        },
        withCredentials: true,
      };

      // Fetch Shariah Risk permissions.
      const shariahResponse = await axios.post(
        getshariahconfig,
        {},
        {
          ...baseConfig,
          params: {
            userId: loggedInUserId,
            templateName: "Shariah Risk",
          },
        }
      );

      const shariahPermissions = Array.isArray(shariahResponse.data?.data)
        ? shariahResponse.data.data
        : [];

      const hasShariahPermission = shariahPermissions.some(
        (item) =>
          String(item.userId) === loggedInUserId &&
          item.download === "Y"
      );

      setCanDownloadShariahReport(hasShariahPermission);

      // Fetch Customer Complaints permissions.
      const complaintsResponse = await axios.post(
        getshariahconfig,
        {},
        {
          ...baseConfig,
          params: {
            userId: loggedInUserId,
            templateName: "Customer Complaints",
          },
        }
      );

      const complaintsPermissions = Array.isArray(complaintsResponse.data?.data)
        ? complaintsResponse.data.data
        : [];

      const hasComplaintsPermission = complaintsPermissions.some(
        (item) =>
          String(item.userId) === loggedInUserId &&
          item.download === "Y"
      );

      setCanDownloadComplaintsReport(hasComplaintsPermission);

      const mediaResponse = await axios.post(
        getshariahconfig,
        {},
        {
          ...baseConfig,
          params: {
            userId: loggedInUserId,
            templateName: "Media Publicity",
          },
        }
      );

      const mediaPermissions = Array.isArray(mediaResponse.data?.data)
        ? mediaResponse.data.data
        : [];

      const hasMediaPermission = mediaPermissions.some(
        (item) =>
          String(item.userId) === loggedInUserId &&
          item.download === "Y"
      );

      setCanDownloadMediaReport(hasMediaPermission);

      const operationalResponse = await axios.post(
        getshariahconfig,
        {},
        {
          ...baseConfig,
          params: {
            userId: loggedInUserId,
            templateName: "Operational Thresholds",
          },
        }
      );

      const operationalPermissions = Array.isArray(operationalResponse.data?.data)
        ? operationalResponse.data.data
        : [];

      const hasOperationalPermission = operationalPermissions.some(
        (item) =>
          String(item.userId) === loggedInUserId &&
          item.download === "Y"
      );

      setCanDownloadOperationalReport(hasOperationalPermission);

      const leadershipResponse = await axios.post(
        getshariahconfig,
        {},
        {
          ...baseConfig,
          params: {
            userId: loggedInUserId,
            templateName: "Leadership Thresholds",
          },
        }
      );

      const leadershipPermissions = Array.isArray(leadershipResponse.data?.data)
        ? leadershipResponse.data.data
        : [];

      const hasLeadershipPermission = leadershipPermissions.some(
        (item) =>
          String(item.userId) === loggedInUserId &&
          item.download === "Y"
      );

      setCanDownloadLeadershipReport(hasLeadershipPermission);

      const complianceResponse = await axios.post(
        getshariahconfig,
        {},
        {
          ...baseConfig,
          params: {
            userId: loggedInUserId,
            templateName: "Leadership Thresholds",
          },
        }
      );

      const compliancePermissions = Array.isArray(complianceResponse.data?.data)
        ? complianceResponse.data.data
        : [];

      const hasCompliancePermission = compliancePermissions.some(
        (item) =>
          String(item.userId) === loggedInUserId &&
          item.download === "Y"
      );

      setCanDownloadComplianceReport(hasCompliancePermission);



    } catch (error) {
      console.error("Error fetching report permissions:", error);

      setCanDownloadShariahReport(false);
      setCanDownloadComplaintsReport(false);
      setCanDownloadMediaReport(false);
      setCanDownloadComplianceReport(false);
      setCanDownloadOperationalReport(false);
      setCanDownloadLeadershipReport(false);

    } finally {
      setIsLoading(false);
    }
  };



  // ---- START THE REPORT GENERATED CODE --------------

  const handleGenerateCheckerReport = async (dateFilterpdf) => {
    const appliedFilter = dateFilterpdf;
    try {
      const userRole = localStorage.getItem("userRole");
      const dept = localStorage.getItem("dept");
      const userId = localStorage.getItem("userid");
      const Userdept = localStorage.getItem("dept");
      const getDisplayDept = (dept) => (dept === "Finance" ? "Finance and Planning" : dept);

      const Activty = 'R';

      const config = {
        headers: { userId, "x-csrf-token": csrfToken },
        withCredentials: true,
        params: {
          userRole, dept,
          dateFilter: appliedFilter,
          Activty: Activty
        },
      };

      const response = await axios.post(CheckerChartreport, {}, config);
      const responseData = response.data || {};
      const allDepartmentData = responseData["data Information"] || {};


      const isITUser = dept === "IT";
      const departmentsToProcess = isITUser ? Object.keys(allDepartmentData) : [dept];


      let allReviewTables = [];
      let allApprovedTables = [];
      let allRejectedTables = [];

      departmentsToProcess.forEach(department => {
        if (!allDepartmentData[department]) return;
        const deptData = allDepartmentData[department];

        const reviewTables = deptData[2]?.["Review Tables"] || [];
        const approvedTables = deptData[0]?.["Approved Tables"] || [];
        const rejectedTables = deptData[1]?.["Rejected Tables"] || [];

        const filterByDate = (tables, key) =>
          tables.filter((item) => isWithinDateRange(item[key], appliedFilter));

        const filteredReview = reviewTables.map(item => ({ ...item, deptName: department }));
        const filteredApproved = filterByDate(approvedTables, "Last Approved Date").map(item => ({ ...item, deptName: department }));
        const filteredRejected = filterByDate(rejectedTables, "Last Rejected Date").map(item => ({ ...item, deptName: department }));

        allReviewTables = [...allReviewTables, ...filteredReview];
        allApprovedTables = [...allApprovedTables, ...filteredApproved];
        allRejectedTables = [...allRejectedTables, ...filteredRejected];
      });

      setReviewTablespdf(allReviewTables);
      setApprovedTablespdf(allApprovedTables);
      setRejectedTablespdf(allRejectedTables);

      const uniqueTables = new Map();

      allRejectedTables.forEach((table) =>
        uniqueTables.set(table["Table Name"] + table.deptName, { ...table, status: "Rejected" })
      );
      allApprovedTables.forEach((table) => {
        const key = table["Table Name"] + table.deptName;
        if (!uniqueTables.has(key)) {
          uniqueTables.set(key, { ...table, status: "Approved" });
        }
      });
      allReviewTables.forEach((table) => {
        const key = table["Table Name"] + table.deptName;
        if (!uniqueTables.has(key)) {
          uniqueTables.set(key, { ...table, status: "Review" });
        }
      });

      const allTables = Array.from(uniqueTables.values());

      const detailData = [
        allReviewTables.length,
        allApprovedTables.length,
        allRejectedTables.length,
      ];
      const totalCount = detailData.reduce((a, b) => a + b, 0);
      if (!totalCount) {
        setModalMessage("No activity is available for the selected Interval");
        setMessageType("warning");
        return;
      }

      let chartImg;

      if (isITUser) {
        const reviewCountsByDept = [];
        const labels = [];
        Object.entries(allDepartmentData).forEach(([department, deptData]) => {
          const reviewCount = deptData?.[2]?.["Review Table count"] || 0;
          if (reviewCount > 0) {
            labels.push(`${department} (${reviewCount})`);
            reviewCountsByDept.push(reviewCount);
          }
        });

        if (reviewCountsByDept.length === 0) {
          setModalMessage("No activity is available for the selected Interval");
          setMessageType("warning");
          return;
        }

        chartImg = await generateCheckerDoughnutChartImage(
          labels,
          reviewCountsByDept
        );
      } else {
        chartImg = await generateCheckerChartImage(
          detailData,
          setModalMessage,
          setMessageType
        );
      }


      const pdf = new jsPDF("l", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const downloadTime = new Date().toLocaleString();
      pdf.setFont("helvetica", "bold");
      pdf.text("Audit Report - Review Summary", pageWidth / 2, 18, {
        align: "center",
      });
      pdf.setFontSize(9);
      pdf.setFont("helvetica", "normal");
      const dateFilterLabels = {
        All: "All Days",
        Today: "Today",
        last3days: "Last 3 Days",
        last7days: "Last 7 Days",
        last30days: "Last 30 Days"
      };

      const reportIntervalLabel = dateFilterLabels[appliedFilter];

      // Meta details
      let y = 25;
      const lineHeight = 5;
      pdf.setFontSize(8);
      pdf.setTextColor(60, 60, 60);

      // Department information based on user type

      pdf.text(`Department : ${getDisplayDept(Userdept)}`, 20, y);
      pdf.text(`Report Interval : ${reportIntervalLabel}`, pageWidth - 20, y, { align: 'right' });

      y += lineHeight;
      pdf.text(`Generated By : ${userId} (${userRole})`, 20, y);
      y += lineHeight;
      pdf.text(`Generated On : ${downloadTime}`, 20, y);

      const imgWidth = 90.23;
      const imgHeight = 70.09;
      const chartX = (pageWidth - imgWidth) / 2;
      const chartY = 45;

      if (chartImg) {
        pdf.addImage(chartImg, "PNG", chartX, chartY, imgWidth, imgHeight);
      }

      const formatTableName = (name) => {
        if (!name) return "-";
        let cleanName = name.includes('_') ? name.substring(name.indexOf('_') + 1) : name;
        cleanName = cleanName.split('_').map(word =>
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        ).join(' ');
        return cleanName.trim();
      };

      const formatDate = (dt) => (dt ? dt.split(" ")[0] : "-");

      const headers = [[
        "S.No",
        ...(isITUser ? ["Department"] : []),
        "Table Name",
        "No.of Columns",
        "No.of Data Reviewed",
        "No.of Data Approved",
        "No.of Data Rejected",
        "No.of Data Pending",
        "Approved By",
        "Approved Date"
        // "Last Rejected By",
        // "Last Rejected Date"
      ]];

      const data = allReviewTables.map((item, index) => {
        const safe = (val) => (val !== undefined && val !== null ? val : "-");

        const baseRow = [
          index + 1,
          ...(isITUser ? [safe(item.deptName)] : []),
          formatTableName(item["Table Name"]),
          safe(item["No.of.columns"]),
          safe(item["overall_submitted_count"]),
          safe(item["Approved Records"]),
          safe(item["Rejected Records"]),
          safe(item["pending Records"]),
          safe(item["Approved_by"]),
          formatDate(item["Last Approved Date"])
          // safe(item["Rejected_by"]),
          // formatDate(item["Last Rejected Date"]),
        ];
        return baseRow;
      });

      autoTable(pdf, {
        startY: chartY + imgHeight + 10,
        head: headers,
        body: data,
        styles: {
          fontSize: 7,
          cellPadding: 1.5,
          halign: "left",
          valign: "middle",
          overflow: "linebreak",
          minCellHeight: 5,
        },
        headStyles: {
          fillColor: [245, 245, 245],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          fontSize: 7,
          lineWidth: 0.1,
          lineColor: 180,
        },
        bodyStyles: {
          textColor: 50,
          lineWidth: 0.1,
          lineColor: 200,
        },
        theme: "grid",
        didDrawPage: () => {
          pdf.setLineWidth(0.8);
          pdf.setDrawColor(0, 0, 0);
          pdf.rect(10, 10, pageWidth - 20, pageHeight - 20);
        },
      });

      pdf.save(`Audit Report - Review Summary_${Date.now()}.pdf`);
    } catch (err) {
      console.error("Failed to generate checker report", err);
    }
  };


  const generateCheckerChartImage = async (detailData) => {
    const canvas = document.getElementById("hiddenCheckerChart");
    if (!canvas) return null;
    // 🚨 Check if all counts are zero
    const totalCount = detailData.reduce((a, b) => a + b, 0);
    if (!totalCount) {
      setModalMessage("No activity is available for the selected Interval");
      setMessageType("warning");
      return null;
    }

    const ctx = canvas.getContext("2d");

    if (canvas._chartInstance) {
      canvas._chartInstance.destroy();
    }

    const [reviewCount, approveCount, rejectCount] = detailData;

    const labels = [
      `Reviewed (${reviewCount})`,
      `Approved (${approveCount})`,
      `Rejected (${rejectCount})`,
    ];

    function createGradient(colorStart, colorEnd) {
      const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
      gradient.addColorStop(0, colorStart);
      gradient.addColorStop(1, colorEnd);
      return gradient;
    }

    const backgroundColors = [];
    backgroundColors.push(createGradient("#967aa1", "#07beb8")); // gradient1
    backgroundColors.push(createGradient("#967aa1", "#f25c54")); // gradient2
    backgroundColors.push(createGradient("#967aa1", "#133c55")); // gradient3
    const chartInstance = new Chart(ctx, {
      type: "bar",
      data: {
        labels,
        datasets: [
          {
            data: detailData,
            backgroundColor: backgroundColors,
            borderRadius: 0,
            barPercentage: 0.5,
            categoryPercentage: 0.5,
          },
        ],
      },
      options: {
        responsive: false,
        animation: false,
        plugins: {
          legend: { display: false },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: "Activity",
              color: "black",
              font: {
                size: 14,
                weight: "bold",
              },
            },
            ticks: {
              color: "black",
              font: {
                size: 16,
                weight: "bold",
              },
            },
            grid: {
              display: false,
            },
          },
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: "Count",
              color: "black",
              font: {
                size: 14,
                weight: "bold",
              },
            },
            ticks: {
              color: "black",
              font: {
                size: 16,
                weight: "bold",
              },
              stepSize: 1,
              precision: 0,
            },
          },
        },
      },
    });

    canvas._chartInstance = chartInstance;

    return new Promise((resolve) => {
      setTimeout(() => {
        const image = canvas.toDataURL("image/png");
        chartInstance.destroy();
        resolve(image);
      }, 300);
    });
  };

  const generateCheckerDoughnutChartImage = async (labels, counts) => {
    const canvas = document.getElementById("hiddenCheckerChartdoughnut");
    if (!canvas) return null;

    const ctx = canvas.getContext("2d");

    if (canvas._chartInstance) {
      canvas._chartInstance.destroy();
    }

    const total = counts.reduce((a, b) => a + b, 0);
    if (total === 0) return null;

    const initialColors = ['#9966FF', '#7AC74F', '#FF69B4', '#FFCE56'];

    function generateSafeColors(count) {
      const colors = [...initialColors];
      let hue = 30;
      while (colors.length < count) {
        if ((hue >= 0 && hue <= 20) || (hue >= 180 && hue <= 260) || (hue >= 340 && hue <= 360)) {
          hue = (hue + 15) % 360;
          continue;
        }
        const color = `hsl(${hue}, 70%, 55%)`;
        if (!colors.includes(color)) {
          colors.push(color);
        }
        hue = (hue + 30) % 360;
      }
      return colors.slice(0, count);
    }

    const backgroundColors = generateSafeColors(counts.length);

    const chartInstance = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels,
        datasets: [
          {
            data: counts,
            backgroundColor: backgroundColors,
            borderColor: "#ffffff",
            borderWidth: 1,
          },
        ],
        totalUsers: total,
      },
      options: {
        responsive: false,
        animation: false,
        cutout: "55%",
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            align: 'center',
            labels: {
              color: 'black',
              font: { size: 12, weight: 'bold', family: 'Arial, sans-serif' },
              boxWidth: 15,
              padding: 10,
              generateLabels(chart) {
                const dataset = chart.data.datasets[0];
                const labels = chart.data.labels;
                return labels.map((label, i) => ({
                  text: `${label}`,
                  fillStyle: dataset.backgroundColor[i],
                  strokeStyle: dataset.borderColor?.[i] || "#fff",
                  lineWidth: 1,
                  hidden: !chart.isDatasetVisible(0),
                  index: i,
                }));
              },
            },
          },
          tooltip: {
            enabled: true,
          },
        },
      },
      plugins: [
        {
          id: 'segment3DEffect',
          afterDatasetDraw(chart) {
            const { ctx } = chart;
            const meta = chart.getDatasetMeta(0);
            const dataset = chart.data.datasets[0];

            ctx.save();
            meta.data.forEach((arc, index) => {
              const { x, y, startAngle, endAngle, outerRadius, innerRadius } = arc;
              const gradient = ctx.createRadialGradient(x, y, innerRadius, x, y, outerRadius);
              const baseColor = dataset.backgroundColor[index];

              gradient.addColorStop(0, 'rgba(255, 255, 255, 0.3)');
              gradient.addColorStop(0.5, baseColor);
              gradient.addColorStop(1, 'rgba(0, 0, 0, 0.15)');

              ctx.fillStyle = gradient;

              ctx.beginPath();
              ctx.moveTo(x, y);
              ctx.arc(x, y, outerRadius, startAngle, endAngle);
              ctx.arc(x, y, innerRadius, endAngle, startAngle, true);
              ctx.closePath();
              ctx.fill();

              ctx.shadowColor = 'rgba(0,0,0,0.08)';
              ctx.shadowBlur = 3;
              ctx.shadowOffsetX = 1;
              ctx.shadowOffsetY = 1;

              ctx.strokeStyle = 'rgba(0, 0, 0, 0.08)';
              ctx.lineWidth = 1;
              ctx.beginPath();
              ctx.arc(x, y, outerRadius, startAngle, endAngle);
              ctx.arc(x, y, innerRadius, endAngle, startAngle, true);
              ctx.closePath();
              ctx.stroke();

              ctx.shadowColor = 'transparent';
              ctx.shadowBlur = 0;
              ctx.shadowOffsetX = 0;
              ctx.shadowOffsetY = 0;
            });
            ctx.restore();
          },
        },
        {
          id: 'centerText',
          beforeDraw(chart) {
            const { ctx, chartArea, data } = chart;
            const total = data.totalUsers || 0;
            ctx.save();
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.font = '20px Arial';
            ctx.fillStyle = 'black';
            ctx.fillText('Total', (chartArea.left + chartArea.right) / 2, (chartArea.top + chartArea.bottom) / 2 - 20);
            ctx.font = '30px Arial';
            ctx.fillText(total.toString(), (chartArea.left + chartArea.right) / 2, (chartArea.top + chartArea.bottom) / 2 + 10);
            ctx.restore();
          },
        },
        {
          id: 'segmentCounts',
          afterDatasetDraw(chart) {
            const { ctx } = chart;
            const dataset = chart.data.datasets[0];
            const meta = chart.getDatasetMeta(0);

            ctx.save();
            ctx.fillStyle = 'black';
            ctx.font = 'bold 14px Arial';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';

            meta.data.forEach((arc, index) => {
              const { x, y } = arc.tooltipPosition();
              const value = dataset.data[index];
              ctx.fillText(value, x, y);
            });

            ctx.restore();
          },
        },
      ],
    });

    canvas._chartInstance = chartInstance;

    return new Promise((resolve) => {
      setTimeout(() => {
        const image = canvas.toDataURL("image/png");
        chartInstance.destroy();
        resolve(image);
      }, 300);
    });
  };

  const isWithinDateRange = (dateStr, range) => {
    if (!dateStr) return false;  // Add null check
    if (range === "all") return true;

    const daysMap = {
      "Today": 0,
      "last3days": 3,
      "last7days": 7,
      "last30days": 30,
    };

    const days = daysMap[range];
    if (days === undefined) return true;

    const targetDate = new Date(dateStr);
    const today = new Date();

    // Reset time components to compare only dates
    today.setHours(0, 0, 0, 0);
    targetDate.setHours(0, 0, 0, 0);

    const diffTime = today - targetDate;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    return diffDays <= days;
  };

  const handleDashboard = (e) => {
    localStorage.removeItem('selectedDept');
    localStorage.removeItem('selectedTable');
    localStorage.removeItem('completedActivity');
    e.preventDefault();
    navigate('/gapsyCdashboard');
  }


  const hanldeReview = (e) => {
    e.preventDefault();
    navigate('/GapsyRData');
  }

  const handleCaudit = (e) => {
    e.preventDefault();
    navigate('/gapsyCaudit');
  }

  const handleTreport = (e) => {
    e.preventDefault();
    navigate('/gapsyTrendreport');
  }


  const handlePortfolioReport = (e) => {
    e.preventDefault();
    navigate('/gapsyReport');
  }

  const handleComplaintsReport = (e) => {
    e.preventDefault();
    navigate('/GapsyComplaintsReport');
  }

  const handleMediaReport = (e) => {
    e.preventDefault();
    navigate('/GapsyMediaReport');
  }

  const handleOperationalReport = (e) => {
    e.preventDefault();
    navigate('/GapsyOperationalReport');
  }

  const handleLeadershipReport = (e) => {
    e.preventDefault();
    navigate('/GapsyLeadershipReport');
  }

  const handleComplianceReport = (e) => {
    e.preventDefault();
    navigate('/GapsyComplianceReport');
  }

  const handleDashboardReport = (e) => {
    e.preventDefault();
    navigate('/GapsyDashboardReport');
  }

  const handleRiskAppetiteReport = (e) => {
    e.preventDefault();
    navigate('/GapsyRiskAppetiteReport');
  }

  const handleShariahReport = (e) => {
    e.preventDefault();
    navigate('/GapsyShariahReport');
  }

  const handleShariah = (e) => {
    e.preventDefault();
    navigate('/gapsyShariahReview');
  }

  const handleShariahList = (e) => {
    e.preventDefault();
    navigate('/gapsyShariahListReview');
  }

  const handleComplaintsList = (e) => {
    e.preventDefault();
    navigate('/gapsyComplaintsListReview');
  }

  const handleMediaList = (e) => {
    e.preventDefault();
    navigate('/gapsyMediaListReview');
  }

  const handleLeadershipList = (e) => {
    e.preventDefault();
    navigate('/gapsyLeadershipListReview');
  }

  const handleOperationalList = (e) => {
    e.preventDefault();
    navigate('/gapsyOperationalListReview');
  }

  const handleComplianceList = (e) => {
    e.preventDefault();
    navigate('/gapsyComplianceListReview');
  }

  const handleNewReport = (e) => {
    e.preventDefault();
    navigate('/gapsyReportListReview');
  }

  const handleResidualOperationalRiskList = (e) => {
    e.preventDefault();
    navigate('/gapsyResidualListReview');
  }

  const handleShariahListReview = (e) => {
    e.preventDefault();
    navigate('/gapsyShariahReviewRetrieval');
  }

  const handleShariahPastApprove = (e) => {
    e.preventDefault();
    navigate('/gapsyShariahPastApprove');
  }

  // const handleCRODashboard = (e) => {
  //   e.preventDefault();
  //   navigate('/GapsyCRODashboard');
  // }

  const handleCloseModal = () => {
    setModalMessage("");
    setMessageType("");
  };

  return (
    <div>
      <nav className={`navbar navbar-expand-lg sticky-nav ${styles.stickyNav} borderBottom`}>
        <div className="container-fluid">
          <ul className="d-flex gap-3 list-unstyled mb-0">
            <li>
              <a className={`${styles.navLink} ${styles.navLinkDefault}
                       ${currentPath === '/gapsyCdashboard' ? styles.active : ''
                }`} href="#" onClick={handleDashboard}>
                <i className="bi bi-display"></i> Home
              </a>
            </li>

            <li className="dropdown">
              <a className={`dropdown-toggle ${styles.navLink} ${styles.navLinkDefault} ${styles.dropdownToggle}
                ${isDataReviewActive ? styles.active : ''}`} href="#" data-bs-toggle="dropdown">
                <i className="bi bi-check-circle"></i> Data Review
              </a>
              <ul className={`dropdown-menu mt-2 rounded-0 ${styles.dropdownMenu} ${styles.dropdownMenuStyled}`}>
                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} href="#" onClick={hanldeReview}>
                    <i className="bi bi-arrow-left-right"></i> 3.1 Approve/Reject
                  </a>
                </li>
              </ul>
            </li>

            <li className={`dropdown ${styles.dropdown}`}>
              <a className={`dropdown-toggle ${styles.navLink} ${styles.navLinkDefault} ${styles.dropdownToggle}
                ${isReportsActive ? styles.active : ''}`} href="#" data-bs-toggle="dropdown">
                <i className="bi bi-box"></i> Reports
              </a>
              <ul className={`dropdown-menu mt-2 rounded-0 ${styles.dropdownMenu} ${styles.dropdownMenuStyled}`}>
                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleCaudit} href="#">
                    <i className="bi bi-file-richtext"></i> Audit Report - Track Changes
                  </a>
                </li>
                <li className={`${styles.dropdownSubmenu}`}>
                  <a
                    className={`dropdown-item dropdown-toggle ${styles.dropdownItem}`}
                    href="#"
                    role="button"
                    aria-expanded="false"
                  >
                    <i className="bi bi-file-richtext"></i>
                    Audit Report - Review Summary
                  </a>

                  <ul className={`dropdown-menu rounded-0 ${styles.submenu} ${styles.dropdownMenuStyled}`}>
                    {["last7days", "last30days", "All"].map((option) => (
                      <li className={`${styles.dropdownSubmenu}`} key={option}>
                        <button
                          className={`dropdown-item ${styles.dropdownItem}`}
                          onClick={() => {
                            setDateFilterpdf(option);
                            handleGenerateCheckerReport(option);
                          }}
                        >
                          {option === "last7days"
                            ? "Last 7 Days"
                            : option === "last30days"
                              ? "Last 30 Days"
                              : "All"}
                        </button>
                      </li>
                    ))}
                  </ul>
                </li>
                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleTreport} href="#">
                    <i className="bi bi-graph-up"></i> Trend Analysis Report
                  </a>
                </li>
                {dept === "Risk" && (
                  <li>
                    <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handlePortfolioReport} href="#">
                      <i className="bi bi-graph-up"></i> Portfolio Report
                    </a>
                  </li>
                )}
                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleDashboardReport} href="#">
                    <i className="bi bi-graph-up"></i> Risk Management Report
                  </a>
                </li>
                <li>
                  <a
                    className={`dropdown-item ${styles.dropdownItem}`}
                    onClick={handleRiskAppetiteReport}
                    href="#"
                  >
                    <i className="bi bi-graph-up"></i> Risk Appetite Report
                  </a>
                </li>
                {/* )} */}
              </ul>
            </li>
            {dept === "Risk" && (
              <li className="dropdown">
                <a className={`dropdown-toggle ${styles.navLink} ${styles.navLinkDefault} ${styles.dropdownToggle}
                ${isDataReviewActive ? styles.active : ''}`} href="#" data-bs-toggle="dropdown">
                  <i className="bi bi-shield-lock"></i> Pillar 2 Risk
                </a>
                <ul className={`dropdown-menu mt-2 rounded-0 ${styles.dropdownMenu} ${styles.dropdownMenuStyled}`}>
                  <li>
                    <a className={`dropdown-item ${styles.dropdownItem}`} href="#" onClick={handleShariahList}>
                      <i className="bi bi-input-cursor-text"></i> Shariah
                    </a>
                  </li>
                  <li>
                    <a className={`dropdown-item ${styles.dropdownItem}`} href="#" onClick={handleResidualOperationalRiskList}>
                      <i className="bi bi-soundwave"></i> Residual Operational Risk
                    </a>
                  </li>
                  {canDownloadShariahReport && (
                    <li>
                      <a
                        className={`dropdown-item ${styles.dropdownItem}`}
                        onClick={handleShariahReport}
                        href="#"
                      >
                        <i className="bi bi-graph-up"></i> Shariah Report
                      </a>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {dept === "Risk" && (
              <li className="dropdown">
                <a className={`dropdown-toggle ${styles.navLink} ${styles.navLinkDefault} ${styles.dropdownToggle}
                ${isDataReviewActive ? styles.active : ''}`} href="#" data-bs-toggle="dropdown">
                  <i className="bi bi-shield-lock"></i> BSF
                </a>
                <ul className={`dropdown-menu mt-2 rounded-0 ${styles.dropdownMenu} ${styles.dropdownMenuStyled}`}>
                  <li>
                    <a className={`dropdown-item ${styles.dropdownItem}`} href="#" onClick={handleComplaintsList}>
                      <i className="bi bi-input-cursor-text"></i> Complaints
                    </a>
                  </li>
                  <li>
                    <a className={`dropdown-item ${styles.dropdownItem}`} href="#" onClick={handleMediaList}>
                      <i className="bi bi-soundwave"></i> Media Publicity
                    </a>
                  </li>
                  <li>
                    <a className={`dropdown-item ${styles.dropdownItem}`} href="#" onClick={handleLeadershipList}>
                      <i className="bi bi-people"></i> Leadership
                    </a>
                  </li>
                  <li>
                    <a className={`dropdown-item ${styles.dropdownItem}`} href="#" onClick={handleOperationalList}>
                      <i className="bi bi-gear"></i> Operational
                    </a>
                  </li>

                  <li>
                    <a className={`dropdown-item ${styles.dropdownItem}`} href="#" onClick={handleComplianceList}>
                      <i className="bi bi-clipboard-check"></i> Compliance
                    </a>
                  </li>

                  {(() => {
                    const title = localStorage.getItem("excelTitle")?.trim();

                    if (!title) return null;

                    return (
                      <li>
                        <a
                          className={`dropdown-item ${styles.dropdownItem}`}
                          onClick={handleNewReport}
                          style={{ cursor: "pointer" }}
                        >
                          <i className="bi bi-file-earmark-text"></i>{" "}
                          {title}
                        </a>
                      </li>
                    );
                  })()}

                </ul>
              </li>
            )}

            {dept === "Risk" && (
              <li className={`dropdown ${styles.dropdown}`}>
                <a className={`dropdown-toggle ${styles.navLink} ${styles.navLinkDefault}`}
                  href="#" data-bs-toggle="dropdown">
                  <i className="bi bi-shield-lock"></i> BSF Reports
                </a>
                <ul className={`dropdown-menu mt-2 rounded-0 ${styles.dropdownMenu} ${styles.dropdownMenuStyled}`}>

                  {canDownloadComplaintsReport && (
                    <li>
                      <a
                        className={`dropdown-item ${styles.dropdownItem}`}
                        onClick={handleComplaintsReport}
                        href="#"
                      >
                        <i className="bi bi-graph-up"></i> Complaints Report
                      </a>
                    </li>
                  )}
                  {canDownloadMediaReport && (
                    <li>
                      <a
                        className={`dropdown-item ${styles.dropdownItem}`}
                        onClick={handleMediaReport}
                        href="#"
                      >
                        <i className="bi bi-graph-up"></i> Media Publicity Report
                      </a>
                    </li>
                  )}
                  {canDownloadLeadershipReport && (
                    <li>
                      <a
                        className={`dropdown-item ${styles.dropdownItem}`}
                        onClick={handleLeadershipReport}
                        href="#"
                      >
                        <i className="bi bi-people"></i> Leadership Report
                      </a>
                    </li>
                  )}
                  {canDownloadOperationalReport && (
                    <li>
                      <a
                        className={`dropdown-item ${styles.dropdownItem}`}
                        onClick={handleOperationalReport}
                        href="#"
                      >
                        <i className="bi bi-gear"></i> Operational Report
                      </a>
                    </li>
                  )}
                  {canDownloadComplianceReport && (
                    <li>
                      <a
                        className={`dropdown-item ${styles.dropdownItem}`}
                        onClick={handleComplianceReport}
                        href="#"
                      >
                        <i className="bi bi-clipboard-check"></i> Compliance Report
                      </a>
                    </li>
                  )}
                </ul>
              </li>
            )}


          </ul>


        </div>

      </nav>

      <canvas
        id="hiddenCheckerChart"
        width={400}
        height={300}
        style={{ display: "none" }}
      ></canvas>

      <canvas
        id="hiddenCheckerChartdoughnut"
        width={300}
        height={250}
        style={{ display: "none" }}
      ></canvas>

      <Modal
        show={!!modalMessage}
        onHide={handleCloseModal}
        backdrop="static"
        keyboard={false}
        style={{ marginTop: '12vh' }}
      >
        <div
          className={`alert alert-${messageType === 'success' ? 'success' : messageType === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`}
          role="alert"
          style={{ marginBottom: '0' }}
        >
          <div className="d-flex align-items-center">
            {messageType === 'success' ? (
              <span className="me-2" style={{ color: 'green', fontSize: '14px' }}>✅</span>
            ) : messageType === 'warning' ? (
              <span className="me-2" style={{ color: '#ffc107', fontSize: '14px' }}>⚠️</span>
            ) : (
              <span className="me-2" style={{ color: 'red', fontSize: '14px' }}>❌</span>
            )}
            <p
              style={{
                display: 'inline',
                marginBottom: '0px',
                color: messageType === 'success'
                  ? 'green'
                  : messageType === 'warning'
                    ? '#ffc107'
                    : 'red'
              }}
            >
              {modalMessage}
            </p>
          </div>
          <button
            type="button"
            className="btn-close"
            onClick={handleCloseModal}
            style={{
              width: '15px',
              height: '15px',
              fontSize: '8px',
              position: 'absolute',
              bottom: '10px',
              right: '10px'
            }}
          />
        </div>
      </Modal>
    </div>

  );
};

export default Navigation;
